<template>
  <div class="homecontainer" :style="' background-color:'+String(backgoundcolor)">
    <!--     <GoodTitle :goodname="goodname" :goodinfo="goodinfo" :fontcolor="fontcolor" />-->
<!--    <div class="with">-->
<!--      <div class="topwith"></div>-->
<!--    </div>-->
    <div class="aboutusbody">
      <h1 class="wow fadeInUp">{{titlename}}</h1>
      <div class="bodybottom wow slideInRight">
        <div v-for="(item,index) in listdata" class="divstyle" >
          <div :class="'imgdiv'+index">
            <img :src="getimgsrc(item.img)"/>
          </div>
          <button  :class="'button'+index"  @click="$router.push(item.router)"
                  v-html="$i18n.locale=='zh_HK'?item.name:item.nameEn">{{$i18n.locale=='zh_HK'?item.name:item.nameEn}}
          </button>
        </div>
      </div>
    </div>
    <img :src="imgsrc" >
  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "Products",
    props: ['titlename','imgsrc', 'backgoundcolor' ,'listdata'],
    data(){
      return{
      }
    },
    methods: {
      routerpush(to) {
        this.$router.push(to)
        location.reload();
      },
    },
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
    methods:{
      getimgsrc(imgvalue) {
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .homecontainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin-top: -18%;
      z-index: 9;
      /*.with {*/
      /*  position: absolute;*/
      /*  display: flex;*/
      /*  background-color: rgba(250, 250, 250, 0.5);*/
      /*  width: 100%;*/
      /*  height: 100%;*/
      /*  top: 0;*/

      /*  .topwith {*/
      /*    position: absolute;*/
      /*    display: flex;*/
      /*    background-color: rgba(250, 250, 250, 0.9);*/
      /*    width: 100%;*/
      /*    height: 14%;*/
      /*    top: 0;*/
      /*  }*/
      /*}*/

      .aboutusbody {
        position: absolute;
        width: 100%;
        max-width: 1630px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        top: 18%;
        z-index: 9999;

        h1 {
          font-size: 3.4em;
          color: black;
        }

        .bodybottom {
          margin-top: 5%;
          display: flex;
          align-items: flex-start;
          width: 95%;
          justify-content: space-around;

          div {
            padding: 10px 0;
            width: 100%;
            color: #fff;

            div {
              border-radius: 50%;
              margin: 0 auto;
              width: 80%;
              height: 0;
              padding-top: 70%;

              img {
                margin-top: -90%;
                transition: all 0.6s; //设置动画执行的时间为0.6s
                cursor: pointer;
              }
            }
            .imgdiv1 {
              margin-top: 20%;
            }
            .imgdiv3 {
              margin-top: 20%;
            }
            img:hover {
              transform: scale(1.02); //设置图片按照比例放大1.2倍
            }
            button {
              position: relative;
              /* Green */
              border: none;
              color: white;
              padding: 10% 15%;
              text-align: center;
              text-decoration: none;
              display: inline-block;
              font-size: 21px;
              margin-top: 50%;
              transition: all 0.4s; //设置动画执行的时间为0.6s
              cursor: pointer;
            }
            button:hover {
              transform: scale(1.04);
            }
            .button0 {
              background-color: #FA0201;
            }
            .button1 {
              background-color: #2B59A6;
              margin-top: 30%;
            }
            .button2 {
              background-color: #D9AB19;
            }
            .button3 {
              background-color: #130639;
              margin-top: 30%;
            }
            .button4 {
              background-color: #21C140;
            }

          }
        }
      }

      img {

        width: 100%;
        height: auto;
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .homecontainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin-top: -18%;
      z-index: 9;
      .with {
        position: absolute;
        display: flex;
        background-color: rgba(250, 250, 250, 0.5);
        width: 100%;
        height: 100%;
        top: 0;

        .topwith {
          position: absolute;
          display: flex;
          background-color: rgba(250, 250, 250, 0.9);
          width: 100%;
          height: 14%;
          top: 0;
        }
      }

      .aboutusbody {
        position: absolute;
        width: 100%;
        max-width: 1630px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 0;
        top: 9%;
        z-index: 9999;

        h1 {
          font-size: 3.2em;
          color: black;
        }

        .bodybottom {
          margin-top: -2%;
          display: flex;
          align-items: flex-start;
          width: 95%;
          justify-content: space-around;

          div {
            padding: 10px 0;
            width: 100%;
            color: #40B3EC;


            .imgdiv {
              /*background: #200A42;*/
              border-radius: 50%;
              margin: 0 auto;
              width: 80%;
              height: 0;
              padding-top: 60%;

              img {
                margin-top: -90%;
              }
              .imgdiv1 {
                margin-top: 20%;
              }
              .imgdiv3 {
                margin-top: 20%;
              }
              img:hover {
                transform: scale(1.05);
              }
            }

            button {
              width: 100%;
              margin: 0 auto;
              position: relative;
              /* Green */
              border: none;
              color: white;
              padding: 10% 1%;
              text-align: center;
              text-decoration: none;
              display: inline-block;
              /*font-size: 0.8em;*/
              transform: scale(0.7);

            }

            /*.button {*/
            /*  margin-top: 11vw;*/
            /*}*/

            /*.button_bo {*/
            /*  margin-top: 7.5vw;*/
            /*}*/
            .button0 {
              background-color: #FA0201;
            }
            .button1 {
              background-color: #2B59A6;
            }
            .button2 {
              background-color: #D9AB19;
            }
            .button3 {
              background-color: #130639;
            }
            .button4 {
              background-color: #21C140;
            }
          }
        }
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/homecomponents/products_home.vue